import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocumentType } from './documenttype';
import { environment } from '../../../environments/environment';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService {
  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;
  //http get method
  Get(): Observable<DocumentType[]> {
    return this.httpClient.get<DocumentType[]>(this.baseUrl + 'api/DocumentTypeApi');
  }

  //http post method
  Post(doctypemodel: DocumentType): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/DocumentTypeApi/add', doctypemodel,
      { headers: header, observe: 'response' });
  }
  //http put method
  Put(doctypemodel: DocumentType): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/DocumentTypeApi/Update', doctypemodel,
      { headers: header, observe: 'response' });
  }

  Delete(doctypemodel: DocumentType): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/DocumentTypeApi/activeordeactive' , doctypemodel,
       { headers: header, observe: 'response' })

  }
}
